import React, { useState } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  sectionItem: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minHeight: 40,
  },
  sectionIcon: {
    minWidth: 32,
    marginRight: theme.spacing(1),
  },
  sectionText: {
    margin: 0,
    '& .MuiListItemText-primary': {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.2,
    },
  },
  expandIcon: {
    minWidth: 24,
  },
  childrenList: {
    paddingLeft: 12,
  },
}));

const CollapsibleMenuSection = ({ 
  title, 
  icon, 
  children, 
  expanded = false,
  onToggle,
  divider = true 
}) => {
  const classes = useStyles();

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <>
      <ListItem 
        button 
        onClick={handleToggle}
        className={classes.sectionItem}
      >
        <ListItemIcon className={classes.sectionIcon}>
          {icon}
        </ListItemIcon>
        <ListItemText 
          primary={title} 
          className={classes.sectionText}
        />
        <div className={classes.expandIcon}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </div>
      </ListItem>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={classes.childrenList}>
          {children}
        </List>
      </Collapse>
      {divider && <Divider />}
    </>
  );
};

export default CollapsibleMenuSection;